import {
    GET_PROJECTS,
    UPDATE_PROJECT,
    CREATE_PROJECT,
    DELETE_PROJECT,
} from '../actions/projects';
import _ from 'lodash';

const INITIAL_STATE = [];

export default function (state = INITIAL_STATE, action) {
    let index = -1;
    switch (action.type) {
        case GET_PROJECTS:
            return [].concat(action.value);

        case UPDATE_PROJECT:
            index = _.findIndex(state, { '_id':  action.value._id});
            state[index] = action.value;
            return [].concat(state);

        case CREATE_PROJECT:
            return [action.value].concat(state);

        case DELETE_PROJECT:
            index = _.findIndex(state, { '_id':  action.value._id});
            if (index !== -1) {
                state.splice(index, 1);
            }
            return [].concat(state);

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/projects.js